module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
  return _h('div', {
    staticClass: "blog"
  }, [_h('div', {
    staticClass: "mt-2"
  }, [_h('router-link', {
    staticClass: "btn btn-primary",
    attrs: {
      "to": "/postedit"
    }
  }, ["Nuevo Post"])]), " ", _h('post-listado', {
    staticClass: "mt-2"
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1c029506!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Blog.vue
// module id = 197
// module chunks = 2